import { memoryStore } from "ra-core";

export const sessionStorageStore = () => {
    const prefix = "RaStore.";
    const store = memoryStore();

    // ==== HIDRATAR SIN NOTIFICAR ====
    const initialState = {};

    Object.keys(sessionStorage).forEach(k => {
        if (k.startsWith(prefix)) {
            const key = k.replace(prefix, "");
            try {
                initialState[key] = JSON.parse(sessionStorage.getItem(k));
            } catch {
                // ignoramos valores rotos
            }
        }
    });

    // esto NO dispara listeners → NO hay re-render
    store._state = initialState;

    // ==== API pública ====
    return {
        ...store,

        async setItem(key, value) {
            sessionStorage.setItem(prefix + key, JSON.stringify(value));
            return store.setItem(key, value); // esto sí debe notificar
        },

        async removeItem(key) {
            sessionStorage.removeItem(prefix + key);
            return store.removeItem(key);
        },

        async clear() {
            Object.keys(sessionStorage)
                .filter(k => k.startsWith(prefix))
                .forEach(k => sessionStorage.removeItem(k));

            return store.clear();
        }
    };
};
